export { default } from './ProductsCarousel';
